import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = "From the first footing to the final board, every Newland project is priced, planned and built by the owner. No hand-offs. No shortcuts. Just honest work that stands up to Tennessee summers.";

const Word = ({ w, i, n, progress }) => {
  const opacity = useTransform(progress, [i / n, (i + 1) / n], [0.12, 1]);
  const y = useTransform(progress, [i / n, (i + 1) / n], [8, 0]);
  return <motion.span style={{ opacity, y }} className="mr-[0.25em] inline-block">{w}</motion.span>;
};

export const Statement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "end 45%"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} data-testid="section-statement" className="bg-[#0A0A0A] px-5 py-28 md:px-10 md:py-40">
      <p className="mx-auto max-w-[1200px] font-display text-3xl font-bold leading-[1.15] tracking-tight text-white md:text-5xl lg:text-6xl">
        {words.map((w, i) => <Word key={i} w={w} i={i} n={words.length} progress={scrollYProgress} />)}
      </p>
    </section>
  );
};
